import React from 'react';
import { X } from 'lucide-react';

export function Modal({ open, onClose, title, children, footer, wide = false }) {
  React.useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-start justify-center overflow-y-auto bg-black/40 p-4 py-10"
      onClick={onClose}>
      <div className={`w-full ${wide ? 'max-w-3xl' : 'max-w-lg'} rounded-2xl bg-white shadow-lift`}
        onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between border-b border-paelbi-line px-6 py-4">
          <h3 className="font-display text-xl text-paelbi-ink">{title}</h3>
          <button onClick={onClose} aria-label="Chiudi" className="text-paelbi-ink/50 hover:text-paelbi-ink"><X size={22} /></button>
        </div>
        <div className="max-h-[65vh] overflow-y-auto px-6 py-5">{children}</div>
        {footer && <div className="flex justify-end gap-3 border-t border-paelbi-line px-6 py-4">{footer}</div>}
      </div>
    </div>
  );
}

export default Modal;
